<template>
  <!--新闻动态-->
  <section id="news">
    <div class="caption">
      <h1>新闻动态</h1>
      <div class="caption-sub middle">
        <div class="flex"></div>
        <span>CASE SHOW</span>
        <div class="flex"></div>
      </div>
    </div>

    <div class="news-list">
      <div v-for="item in list" :key="item.id" class="news">
        <div class="date">{{date2Str(item.create_time, "MM/dd")}}</div>
        <div class="article">
          <a :href="'/news/detail/'+item.id">{{item.title}}</a>
          <p>{{eraseHtml(item.content)}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { eraseHtml, date2Str, str2Date } from "@/assets/js/utils.js";
import newsList from "../news/newsList";

export default {
  data() {
    return {
      list: newsList.sort((x, y) => y.id - x.id).slice(0, 4)
    };
  },
  methods: {
    eraseHtml: eraseHtml,
    date2Str: date2Str,
    str2Date: str2Date
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

$SIZE_OFFSET: 5vw; // 整体向左偏移量
$SIZE_SPACE: 10vw; // 两栏间距

section#news {
  display: flex;
  flex-direction: column;
  align-items: center;

  > .caption {
    margin-top: 0.23rem;
    margin-bottom: 0.3rem;
  }

  > .news-list {
    display: flex;
    flex-wrap: wrap;
    width: $SIZE_PAGE_WIDTH + $SIZE_OFFSET;
    margin-left: -1 * $SIZE_OFFSET;

    > .news {
      display: flex;
      flex-grow: 1;
      width: ($SIZE_PAGE_WIDTH + $SIZE_OFFSET - $SIZE_SPACE) / 2;
      padding-bottom: 0.32rem;

      &:nth-child(odd) {
        margin-right: $SIZE_SPACE;
      }
      // &:nth-child(even) {
      //   padding-left: ($SIZE_SPACE - $SIZE_OFFSET) / 2;
      // }

      > .date {
        width: $SIZE_OFFSET;
        font-size: 18px;
        font-weight: 500;
        color: #145a84;
      }

      > .article {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // flex-grow: 1;
        width: ($SIZE_PAGE_WIDTH - $SIZE_SPACE - $SIZE_OFFSET) / 2;

        > a {
          width: ($SIZE_PAGE_WIDTH - $SIZE_SPACE - $SIZE_OFFSET) / 2;
          margin-bottom: 15px;
          font-size: 18px;
          font-weight: 500;
          color: #145a84;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        > p {
          font-size: 17px;
          text-align: justify;
          color: #666666;
          line-height: 30px;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
}
</style>